import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { FileType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentFileEditItem extends IEditItem {
    code: string;
    comment: string;
    fileType: FileType;
    image: string;
    keywordIds: string[];
    createUser: IModifyUser;
    modifyUser: IModifyUser;
}

export class DocumentFileEditItem extends EditItem implements IDocumentFileEditItem {
    code: string;
    comment: string;
    fileType: FileType;
    image: string;
    keywordIds: string[];
    createUser: IModifyUser;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IDocumentFileEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.fileType = obj && obj.fileType || FileType.Unknown;
        this.image = obj && obj.image || "";
        this.keywordIds = obj && obj.keywordIds || [];
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}